import { IntegrationControl } from "../integration/integrationcontrol/integration.control";
import { IntegrationWizardFinishPage } from "../integration/integrationwizard/iw.finish.page";
import { IntegrationWizardMigrationPage } from "../integration/integrationwizard/iw.migration.page";
import { IntegrationWizardSummaryPage } from "../integration/integrationwizard/iw.summary.page";
import { IntegrationWizardUploadPage } from "../integration/integrationwizard/iw.upload.page";
import { SmartIntegrationControl } from '../integration/smartintegration/smart.integration.control';
import { SmartIntegrationWizardFilterPage } from '../integration/smartintegration/smartintegrationwizard/siw.filter.page';
import { SmartIntegrationWizardFinishPage } from '../integration/smartintegration/smartintegrationwizard/siw.finish.page';
import { SmartIntegrationWizardSourcePage } from '../integration/smartintegration/smartintegrationwizard/siw.source.page';
import { SmartIntegrationWizardSourceTablePage } from '../integration/smartintegration/smartintegrationwizard/siw.source.table.page';
import { SmartIntegrationWizardTargetPage } from '../integration/smartintegration/smartintegrationwizard/siw.target.page';
import { SmartIntegrationWizardUseCasePage } from '../integration/smartintegration/smartintegrationwizard/siw.use.case.page';

export const APP_INTEGRATION = [
    IntegrationControl,
    SmartIntegrationControl,
    IntegrationWizardUploadPage,
    IntegrationWizardMigrationPage,
    IntegrationWizardSummaryPage,
    IntegrationWizardFinishPage,
    SmartIntegrationWizardSourcePage,
    SmartIntegrationWizardUseCasePage,
    SmartIntegrationWizardSourceTablePage,
    SmartIntegrationWizardTargetPage,
    SmartIntegrationWizardFilterPage,
    SmartIntegrationWizardFinishPage
];
